import { useEffect, useState } from "react";

import { RVFormFloatingLabelWrap, RVTypeaheadSelect } from "@regal-voice/ui";
import { useEventSchemaForTypeahead } from "ServerData/EventSchema/Hooks/useEventSchemaForTypeahead/useEventSchemaForTypeahead";

import { useQueryContactAttributes } from "../../../../../shared/hooks/useQueryContactAttributes";

import type { EventSchemaOptionEntry } from "ServerData/EventSchema/eventSchemaTypes";

export function ContactAttributeAutoCompleteFormItem({
    contactAttribute,
    filterAttributes,
}: {
    contactAttribute: string;
    filterAttributes?: (x: Record<string, any>) => Record<string, any>;
}): JSX.Element {
    // @TODO replace with useContactAttributesFullListQuery, no need for the useEffect
    // @see src/ServerData/EventSchema/Hooks/useContactAttributesQuery/useContactAttributesQuery.ts
    /* Getting the contact fields */
    const { loadContactAttributes, contactAttributes } = useQueryContactAttributes({});
    const [contactAttributesSchema, setContactAttributesSchema] = useState<EventSchemaOptionEntry>(contactAttributes);

    useEffect(() => {
        loadContactAttributes();
    }, [contactAttribute]);

    useEffect(() => {
        let attributes = contactAttributes;
        if (filterAttributes) {
            attributes = filterAttributes(contactAttributes);
        }

        setContactAttributesSchema(attributes);
    }, [contactAttribute, contactAttributes]);

    const contactAttributeTypeahead = useEventSchemaForTypeahead({ eventSchema: contactAttributesSchema });

    return (
        <RVFormFloatingLabelWrap
            name="contactAttribute"
            placeholder="Select Attribute Name"
            rules={[
                {
                    required: true,
                    message: "Select contact attribute",
                },
            ]}
        >
            <RVTypeaheadSelect {...contactAttributeTypeahead} />
        </RVFormFloatingLabelWrap>
    );
}
